import gql from 'graphql-tag'

export const CREATE_WORKSHOP = gql`
  mutation CreateWorkshop($eventId: ID!, $workshopData: WorkshopInput!) {
    createWorkshop(workshopData: $workshopData, eventId: $eventId) {
      id
    }
  }
`
export const DELETE_WORKSHOP = gql`
  mutation DeleteWorkshop($eventId: ID!, $workshopId: ID!) {
    deleteWorkshop(eventId: $eventId, workshopId: $workshopId)
  }
`

export const GET_EVENT_WORKSHOPS = gql`
  query GetWorkshops($eventId: ID!) {
    getWorkshops(eventId: $eventId) {
      id
      name
      unlimitedAttendance
      attendanceLimit
      attending
      to
      from
    }
  }
`
export const GET_EVENT_WORKSHOP_AND_HALLS = gql`
  query GetWorkshop($eventId: ID!, $workshopId: ID!) {
    getHalls(eventId: $eventId){
      id
      name
    }
    getWorkshop(eventId: $eventId, workshopId: $workshopId) {
      id
      name
      hall {
        id
        name
      }
      lecturers {
        id
        fields
      }
      description
      unlimitedAttendance
      attendanceLimit
      to
      from
      event {
        id
        to
        from
        extraModules {
          mobileApp
        }
      }
      attendees {
        id, fields
      }
      attending
    }
  }
`

export const UPDATE_WORKSHOP = gql`
  mutation UpdateWorkshop($eventId: ID!, $workshopData: WorkshopUpdateInput!) {
    updateWorkshop(eventId: $eventId, workshopData: $workshopData)
  }
`

export const REMOVE_WORKSHOP_ATTENDEE = gql`
  mutation RemoveWorkshopAttendee($attendeeId: ID!, $workshopId: ID!, $eventId: ID!) {
    removeWorkshopAttendee(attendeeId: $attendeeId, workshopId: $workshopId , eventId: $eventId )
  }
`
